// Função utilitária para buscar endereço pelo Google Maps
export async function getAddressFromCoords(lat: number, lon: number): Promise<string | null> {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  
  if (!apiKey) {
    console.error('Google Maps API Key não configurada (REACT_APP_GOOGLE_API_KEY)');
    return null;
  }

  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}&language=pt-BR`;

  try {
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    
    const data = await response.json();

    if (data.status !== 'OK') {
      console.warn(`Erro na API do Google Maps: ${data.status} - ${data.error_message || ''}`);
      return null;
    }

    if (data.results && data.results.length > 0) {
      // Tenta encontrar o resultado mais preciso (geralmente o primeiro 'street_address' ou 'premise')
      const result = data.results[0];
      
      // Mapeamento dos componentes do endereço
      let rua = '';
      let numero = '';
      let bairro = '';
      let cidade = '';
      let estado = '';
      let cep = '';

      result.address_components.forEach((component: any) => {
        const types = component.types;
        
        if (types.includes('route')) {
          rua = component.long_name;
        } else if (types.includes('street_number')) {
          numero = component.long_name;
        } else if (types.includes('sublocality') || types.includes('sublocality_level_1')) {
          bairro = component.long_name;
        } else if (types.includes('administrative_area_level_2')) {
          cidade = component.long_name;
        } else if (types.includes('administrative_area_level_1')) {
          estado = component.short_name;
        } else if (types.includes('postal_code')) {
          cep = component.long_name;
        }
      });

      // Formatação similar à anterior para manter consistência
      const ruaNumero = rua ? (numero ? `${rua}, ${numero}` : rua) : '';
      
      const enderecoParts = [
        ruaNumero,
        bairro,
        cidade,
        estado,
        cep
      ].filter(Boolean);

      // Se conseguiu extrair partes significativas, monta o endereço
      if (enderecoParts.length > 0) {
        return enderecoParts.join(', ');
      }
      
      // Fallback para o endereço formatado retornado pelo Google
      return result.formatted_address;
    }
    
    return null;
  } catch (error) {
    console.error('Erro ao buscar endereço no Google Maps:', error);
    return null;
  }
}
